import { createReducer, on } from '@ngrx/store';
import { ColorThemeInterface } from '../types';
import * as ColorThemeActions from './actions';

export const initialState: ColorThemeInterface = {
  selectedColor: '',
};

export const ColorThemeReducers = createReducer(
  initialState,
  on(ColorThemeActions.setColorTheme, (state, action) => ({
    selectedColor: action.selectedColor,
  })),
);
